import { defineComponent as _defineComponent } from 'vue'
import ProgressBar from '@/components/common/ProgressBar.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseProgressOverview',
  props: {
    progressPercentage: {
      type: Number,
      required: true,
    },
  },
  emits: ['toggle-continue'],
  setup(__props) {

  const { arrowRight } = useIcons()

  

  

return { __sfc: true,arrowRight, ProgressBar, KetchUpButton, SVGRenderer, useIcons }
}

})